import { useCallback } from "react";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { MY_CAFETERIA_DELETE_ASSET } from "my-cafeteria/graphql";
import { MY_HR_GET_CHANGE_REQUESTS_ATTACHEMENT } from "my-hr/graphql";
import { useOcCurrentUserState } from "oc/hooks";

export const useOcAssets = ({ type }: { type: string }) => {
  let { employeeCode } = useOcCurrentUserState();
  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CHANGE_REQUESTS_ATTACHEMENT,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        employeeCode,
        type,
      },
    },
  );
  const result = data?.listAttachementByEmployee || [];

  const [deleteAssetMutation] = useMutation(MY_CAFETERIA_DELETE_ASSET);

  const deleteAsset = useCallback(
    async (options?: any) => {
      try {
        const result = await deleteAssetMutation(options);
        refetch();
        return result;
      } catch (error) {
        console.log({ error });
        throw error;
      }
    },
    [deleteAssetMutation, refetch],
  );

  return {
    data: result,
    loading,
    error,
    refetch,
    deleteAsset,
  };
};

export default useOcAssets;
